import { generateClient } from 'aws-amplify/api'
import { listOutboundActions } from '@/graphql/queries'
import { parseAwsJson } from '@/utils/graphql'
import { getApiMessage } from '@/mixins/Extras/ApiResponse'

const client = generateClient()

export async function fetchOutboundActions(input = {}) {
  try {
    const { data, errors } = await client.graphql({
      query: listOutboundActions,
      variables: { input },
    })

    if (errors?.length) {
      throw new Error(errors[0].message)
    }

    return parseAwsJson(data?.listOutboundActions)
  } catch (error) {
    return {
      status: 'ERROR',
      message: getApiMessage(error, 'Failed to load post-call actions'),
    }
  }
}
